import { render, staticRenderFns } from "./ChipClosable.vue?vue&type=template&id=7a2cf302&"
import script from "./ChipClosable.vue?vue&type=script&lang=js&"
export * from "./ChipClosable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports